import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Combobox, Icon } from '@salesforce/design-system-react';

import comboboxFilterAndLimit from '@salesforce/design-system-react/components/combobox/filter';

class OppCombobox extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    inputValue: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);

    this.state = {
      labels: {
        label: 'Opportunity Lookup',
        placeholder: 'Search for an opportunity in Org62...',
      },
      selection: [],
    };
  }

  onChange = (event, { value }) => {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  onRemove = (event, data) => {
    // clear the input search
    this.props.onChange('');
    this.setState({
      selection: data.selection,
    });
  };

  onSubmit = () => {};

  onSelect = (event, data) => {
    if (this.props.onSelect) {
      this.props.onSelect(event, ...Object.keys(data).map((key) => data[key]));
    }
    // clear the input search
    this.props.onChange('');
    this.setState({
      selection: data.selection,
    });
  };

  render() {
    return (
      <Combobox
        id="combobox-inline-single"
        events={{
          onChange: this.onChange,
          onRequestRemoveSelectedOption: this.onRemove,
          onSubmit: this.onSubmit,
          onSelect: this.onSelect,
        }}
        hasStaticAlignment
        menuPosition="relative"
        variant="inline-listbox"
        selection={this.state.selection}
        value={this.props.inputValue}
        labels={this.state.labels}
        hasMenuSpinner={this.props.isLoading}
        options={comboboxFilterAndLimit({
          inputValue: this.props.inputValue,
          options: this.props.options.map((elem) => ({
            ...elem,
            ...{
              icon: (
                <Icon
                  assistiveText={{ label: 'Opportunity' }}
                  category="standard"
                  name="opportunity"
                  size="small"
                />
              ),
            },
          })),
          selection: this.state.selection,
        })}
      />
    );
  }
}
export default OppCombobox;
